export const convertToCurrencySymbol = (currency: string) => {
    switch (currency) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        default:
            return '$';
    }
};
